export default "__VITE_ASSET__BFM07njN__"